<app-view-item *ngIf="readonly && selected" [text]="selected?.code + ' - ' + selected?.name" [borderless]="borderless"></app-view-item>
<app-view-item *ngIf="readonly && !selected" [text]="''" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!readonly"
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  [nzCustomTemplate]="displayTpl"
  [nzDropdownRender]="renderTemplate"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzOptionHeightPx]="55"
  [nzBorderless]="borderless"
  [nzAllowClear]="allowClear"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="getLabel(o)" nzCustomContent>
      <div><strong>{{ o.code }}</strong></div>
      <div><small>{{ o.name }}</small></div>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #renderTemplate>
  <nz-spin *ngIf="loading"></nz-spin>
  <nz-divider class="m-none"></nz-divider>
</ng-template>
